import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TdNumberValueEditableComponent } from './td-number-value-editable.component';
import { NumberModule } from 'libraries/module/formbuilder/fields/number/number.module';


@NgModule({
    imports: [
        CommonModule,
        NumberModule,
    ],
    exports: [
        TdNumberValueEditableComponent,
    ],
    declarations: [
        TdNumberValueEditableComponent,
    ],
})
export class TdNumberValueEditableModule { }
